import { gql, TypedDocumentNode, useApolloClient } from '@apollo/client';
import { ProductLimitsPeriod, QueryProductLimitsArgs } from 'generated/graphql';
import { MEASURE_FIELDS, NULLABLE_MEASURE_FIELDS } from 'queries';
import { useAsync } from 'react-use';

interface ProductLimitsResponse {
  productLimits: ProductLimitsPeriod[];
}

const productLimitsQuery: TypedDocumentNode<ProductLimitsResponse, QueryProductLimitsArgs> = gql`
  query ProductLimits($deviceInternalId: String!, $from: DateTime!, $to: DateTime!) {
    productLimits(deviceInternalId: $deviceInternalId, from: $from, to: $to) {
      productLimits {
        product
        doubleStrokeLowerLimit {
          ...MeasureFields
        }
        doubleStrokeUpperLimit {
          ...MeasureFields
        }
        contractLowerLimit {
          ...NullableMeasureFields
        }
        contractUpperLimit {
          ...NullableMeasureFields
        }
        flexBandLimit {
          ...NullableMeasureFields
        }
        # controllableLimits {
        #   month
        #   lowerLimit {
        #     ...NullableMeasureFields
        #   }
        #   upperLimit {
        #     ...NullableMeasureFields
        #   }
        # }
      }
      validFrom
      validTo
    }
  }
  ${MEASURE_FIELDS}
  ${NULLABLE_MEASURE_FIELDS}
`;

export function useProductLimits(
  deviceInternalId: string,
  from: Date,
  to: Date,
): ReadonlyArray<ProductLimitsPeriod> | undefined {
  const client = useApolloClient();

  const { value } = useAsync(async () => {
    const { data } = await client.query({
      query: productLimitsQuery,
      variables: { deviceInternalId, from, to },
    });

    return data.productLimits;
  }, [deviceInternalId]);

  return value;
}
